import messages from '../../../i18n/en';
const localeMap = {
  pt: 'pt-BR',
  'pt-PT': 'pt-BR',
  'en-AU': 'en-GB'
};
export const fetchMessagesForLocale = async locale => {
  try {
    var _ref, _localeMap$locale;
    const targetLocale = ((_ref = (_localeMap$locale = localeMap[locale]) !== null && _localeMap$locale !== void 0 ? _localeMap$locale : locale) !== null && _ref !== void 0 ? _ref : '').replace('-', '_');
    if (!targetLocale) {
      throw new Error('No mapped locale');
    }
    const messages = await import( /* webpackChunkName: "@atlaskit-internal_@atlassian/ad-control-toolkit-i18n-[request]" */`../../../i18n/${targetLocale}`);
    return messages.default;
  } catch (e) {
    // ignore
  }
  try {
    const parentLocale = locale.split(/[-_]/)[0];
    const messages = await import( /* webpackChunkName: "@atlaskit-internal_@atlassian/ad-control-toolkit-i18n-[request]" */`../../../i18n/${parentLocale}`);
    return messages.default;
  } catch (e) {
    // ignore
  }

  /**
   * English bundled by default as this is the majority of users
   */
  return messages;
};